// Imports
  // Components
  import CartWidgetCounter from './CartWidgetCounter';
  import CartItemList from './CartItemList';
  // Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faCartShopping } from "@fortawesome/free-solid-svg-icons"




// snippet: rafce

const CartWidget = () => {

  let cartClosed = true;

  // Click en button
    const widgetHandler = () =>{
      const cartItems = document.getElementsByClassName('cart-item-container')[0];
      if(cartClosed){
        cartItems.classList.add('display-flex-from-upper-right');
        cartClosed = false;
      }
      else{
        cartItems.classList.remove('display-flex-from-upper-right');
        cartClosed = true;
      }
    }
    
    // Click afuera
      window.addEventListener('click', function(e){
        const cartItems = document.getElementsByClassName('cart-item-container')[0];
        const cartButton = document.getElementsByClassName('cartWidget-container')[0];
        const completeOrder = document.getElementsByClassName('complete-order')[0];
        if(!cartItems.contains(e.target) && !cartButton.contains(e.target) && !completeOrder.contains(e.target)){
          cartItems.classList.remove('display-flex-from-upper-right');
          cartClosed = true;
          completeOrder.classList.remove('display-flex-from-right');
        }
      }
    )

 
    

  return (
    <div>
      <div className='cartWidget-container' onClick={widgetHandler}>
        <FontAwesomeIcon className="cartWidget" icon={ faCartShopping } size="2x" />
        <CartWidgetCounter></CartWidgetCounter>
      </div>
      <CartItemList />
    </div>
  )
}

export default CartWidget
